import { gql } from '@apollo/client';

const ERRORS = `errors { path, message }`;

const MEDICINE_CORE_FIELDS = gql`
  fragment MedicineCoreFields on Medicine {
    id
    name
    alternateNames
    emoji
    doseAmount
    doseType
    startOn
    endOn
    value: id
    label: name
  }
`;

export const MEDICINE_FIELDS = gql`
  ${MEDICINE_CORE_FIELDS}
  fragment MedicineFields on Medicine {
    ...MedicineCoreFields
    client { id, name }
  }
`;

export const MEDICINE = gql`
  ${MEDICINE_FIELDS}
  query Medicine($id: ID!) {
    medicine(id: $id) {
      ...MedicineFields
    }
  }
`;

export const MEDICINES = gql`
  ${MEDICINE_FIELDS}
  query Medicines (
    $limit: Int!
    $offset: String!
    $options: ConnectionOptionsInput!
  ) {
    medicines (
      first: $limit
      after: $offset
      options: $options
    ) {
      edges {
        cursor
        node {
          ...MedicineFields
        }
      }
      totalCount
    }
  }
`;

export const SUGGEST_MEDICINES = gql`
  ${MEDICINE_FIELDS}
  query SuggestMedicines (
    $clientId: ID
    $eventTypeId: ID
    $eventId: ID
    $all: Boolean
  ) {
    medicines: suggestMedicines (
      clientId: $clientId
      eventTypeId: $eventTypeId
      eventId: $eventId
      all: $all
    ) {
      ...MedicineFields
    }
  }
`;

export const CREATE_MEDICINE = gql`
  ${MEDICINE_CORE_FIELDS}
  mutation CreateMedicine ($input: CreateMedicineInput!) {
    createMedicine (input: $input) {
      medicine {
        ...MedicineCoreFields
      }
      ${ERRORS}
    }
  }
`;

export const UPDATE_MEDICINE = gql`
  ${MEDICINE_CORE_FIELDS}
  mutation UpdateMedicine ($input: UpdateMedicineInput!) {
    updateMedicine (input: $input) {
      medicine {
        ...MedicineCoreFields
      }
      ${ERRORS}
    }
  }
`;
